/**
 * File: FeedbackMessage.tsx
 * Description: Success and error message component for feedback
 * Author: System
 * Created: 2025-10-06
 * Last Modified: 2025-10-06
 */

import {
  HandThumbUpIcon as HandThumbUpSolidIcon,
  HandThumbDownIcon as HandThumbDownSolidIcon,
} from '@heroicons/react/24/solid';
import React from 'react';

import type { FeedbackMessageProps } from './types';

export const FeedbackMessage: React.FC<FeedbackMessageProps> = ({
  submitSuccess,
  submitError,
}) => {
  if (submitSuccess) {
    return (
      <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-md">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <HandThumbUpSolidIcon className="h-4 w-4 text-green-400" />
          </div>
          <div className="ml-2">
            <p className="text-sm text-green-800">
              Thank you for your feedback! It has been submitted successfully.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (submitError) {
    return (
      <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <HandThumbDownSolidIcon className="h-4 w-4 text-red-400" />
          </div>
          <div className="ml-2">
            <p className="text-sm text-red-800">
              Failed to submit feedback: {submitError}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};
